import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@/components/layout/Page';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PageHeader } from '@/components/composed/PageHeader';
import { RouteError } from '@/components/composed/RouteError';
import { NotFound } from '@/components/composed/NotFound';
import { usePageMeta } from '@/app/shell/use-page-meta';

/*
 * Admin landing (spec §3.6). The `/admin` route is now the area layout
 * (<Outlet/>); this index is what shows at `/admin` itself. The area guard on
 * the parent is the backstop, so this needs no guard of its own.
 */
export const Route = createFileRoute('/_auth/admin/')({
  component: AdminIndexPage,
  errorComponent: RouteError,
  notFoundComponent: NotFound,
});

function AdminIndexPage() {
  usePageMeta({ title: 'Administration' });
  return (
    <Page>
      <PageHeader title="Administration" />
      <Card>
        <CardHeader>
          <CardTitle>Tools</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Admin-only tools live here (user management, system settings).
        </CardContent>
      </Card>
    </Page>
  );
}
